export const chipMap = {
    layout: {
        id: '260173',
        name: 'layout',
        type: 'struct',
        title: '通栏',
        groupName: '通栏'
    },
    mainImage: {
        id: '221378',
        name: 'mainImage',
        type: 'static',
        title: '主图',
        groupName: '主图',
    },
    nav: {
        id: '260171',
        name: 'nav',
        type: 'struct',
        title: '导航栏',
        groupName: '导航栏',
    },
    smallBanner1: {
        id: '221379',
        name: 'smallBanner1',
        type: 'static',
        title: '小banner',
        groupName: 'part1'
    },
    newsList: {
        id: '285762',
        name: 'newsList',
        type: 'recommend',
        title: '要闻',
        groupName: 'part1',
    },
    boldNews: {
        id: '285779',
        name: 'boldNews',
        type: 'recommend',
        title: '加粗要闻',
        groupName: 'part1',
    },
    boldSubNews: {
        id: '285780',
        name: 'boldSubNews',
        type: 'recommend',
        title: '加粗要闻下的小新闻',
        groupName: 'part1',
    },
    smallBanner2: {
        id: '221380',
        name: 'smallBanner2',
        type: 'static',
        title: '小banner',
        groupName: 'part1'
    },
    track: {
        id: '285763',
        name: 'track',
        type: 'recommend',
        title: '热点追踪',
        groupName: 'part1',
    },
    smallBanner3: {
        id: '221381',
        name: 'smallBanner3',
        type: 'static',
        title: '小banner',
        groupName: 'part1'
    },
    focus: {
        id: '285764',
        name: 'focus',
        type: 'recommend',
        title: '焦点图',
        groupName: 'part1',
    },
    smallBanner4: {
        id: '221382',
        name: 'smallBanner4',
        type: 'static',
        title: '小banner',
        groupName: 'part1'
    },
    videoList: {
        id: '285765',
        name: 'videoList',
        type: 'recommend',
        title: '视频列表',
        groupName: 'part1',
    },
    bigBanner1: {
        id: '221383',
        name: 'bigBanner1',
        type: 'static',
        title: '大banner',
        groupName: 'part2'
    },
    articleBox1: {
        id: '285766',
        name: 'articleBox1',
        type: 'recommend',
        title: '图文列表1',
        groupName: 'part2'
    },
    bigBanner2: {
        id: '221384',
        name: 'bigBanner2',
        type: 'static',
        title: '大banner',
        groupName: 'part3'
    },
    imageArticleList: {
        id: '285767',
        name: 'imageArticleList',
        type: 'recommend',
        title: '漫画列表',
        groupName: 'part3'
    },
    bigBanner3: {
        id: '221385',
        name: 'bigBanner3',
        type: 'static',
        title: '大banner',
        groupName: 'part4'
    },
    tabs: {
        id: '285768',
        name: 'tabs',
        type: 'recommend',
        title: 'tabs',
        groupName: 'part4'
    },
    bigBanner4: {
        id: '221386',
        name: 'bigBanner4',
        type: 'static',
        title: '大banner',
        groupName: 'part5'
    },
    swiper: {
        id: '285769',
        name: 'swiper',
        type: 'recommend',
        title: '大轮播图',
        groupName: 'part5'
    },
    bigBanner5: {
        id: '221387',
        name: 'bigBanner5',
        type: 'static',
        title: '大banner',
        groupName: 'part6'
    },
    articleBox2: {
        id: '285770',
        name: 'articleBox2',
        type: 'recommend',
        title: '图文列表2',
        groupName: 'part6'
    },
    bigBanner6: {
        id: '221388',
        name: 'bigBanner6',
        type: 'static',
        title: '大banner',
        groupName: 'part7'
    },
    articleBox3: {
        id: '285771',
        name: 'articleBox3',
        type: 'recommend',
        title: '图文列表3',
        groupName: 'part7'
    },
    bigBanner7: {
        id: '221389',
        name: 'bigBanner7',
        type: 'static',
        title: '大banner',
        groupName: 'part8'
    },
    matirx: {
        id: '285772',
        name: 'matirx',
        type: 'recommend',
        title: '矩阵',
        groupName: 'part8'
    },
    bigBanner8: {
        id: '221390',
        name: 'bigBanner8',
        type: 'static',
        title: '大banner',
        groupName: 'part9'
    },
    support: {
        id: '260172',
        name: 'support',
        type: 'struct',
        title: '赞助',
        groupName: 'part10'
    },
    bigBanner9: {
        id: '221439',
        name: 'bigBanner9',
        type: 'static',
        title: '大banner',
        groupName: 'part10'
    }
};

export const adMap = {
    ad1: {
        name: 'ad1',
        id: 'adchip_news/s_lh_200429_index_ad_banner01.inc.html',
        type: 'ad',
        title: '通栏广告1'
    },
    ad2: {
        name: 'ad2',
        id: 'adchip_news/s_lh_200429_index_ad_banner02.inc.html',
        type: 'ad',
        title: '通栏广告2'
    },
    ad3: {
        name: 'ad3',
        id: 'adchip_news/s_lh_200429_index_ad_banner03.inc.html',
        type: 'ad',
        title: '通栏广告3'
    },
    ad4: {
        name: 'ad4',
        id: 'adchip_news/s_lh_200429_index_ad_banner04.inc.html',
        type: 'ad',
        title: '通栏广告4'
    },
    ad5: {
        name: 'ad5',
        id: 'adchip_news/s_lh_200429_index_ad_couplet.inc.html',
        type: 'ad',
        title: '对联广告'
    },
    ad6: {
        name: 'ad6',
        id: 'adchip_news/s_lh_200429_index_ad_media.inc.html',
        type: 'ad',
        title: '视窗广告'
    },
    ad8: {
        name: 'ad8',
        id: 'adchip_news/s_lh_200508_index_ad_bannertop.inc.html',
        type: 'ad',
        title: '顶部通栏广告'
    }
};
